<template>
    <div>
        <v-card class="col-item" flat style="border-top: 1px solid lightgray">
            <v-data-table
                :headers="tableHeaders"
                class="payment-imports-table"
                dense
                :items="paymentImports"
                :items-per-page="25"
                :hide-default-footer="true"
            >
                <template v-slot:item="{ item }">
                    <tr
                        :key="'pi_' + item.id"
                        @click="handleDownloadClick(item)"
                        :class="{ 'badge-link': item.status === 'finished' }"
                    >
                        <td>{{ item.id }}</td>
                        <td>{{ item.uploaded_at ? tz(item.uploaded_at) : "-" }}</td>
                        <td>{{ item.rows ? item.rows : "-" }}</td>
                        <td style="text-align: end">{{ item.type ? item.type.toUpperCase() : "-" }}</td>
                        <td style="text-align: center">
                            <span
                                v-if="item.status === 'finished'"
                                @click="handleDownloadClick(item)"
                                :class="item.badgeClasses"
                                >{{ status(item) }}</span
                            >
                            <v-tooltip
                                left
                                v-else-if="item.status === 'failed' && item.errors && item.errors.length > 0"
                                style="white-space: pre-wrap;"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <span :class="item.badgeClasses" v-bind="attrs" v-on="on">{{ status(item) }}</span>
                                </template>
                                <p
                                    class="ma-0 pa-0"
                                    style="font-size: smaller"
                                    v-for="error in item.errors.split(',')"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </v-tooltip>
                            <span v-else class="badge-link" :class="item.badgeClasses">{{ status(item) }}</span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import { mapState } from "vuex";
import settings from "@/settings";

export default {
    name: "csv-list",
    data() {
        return {
            fileUploadValue: null,
            size_error: false,
            tableHeaders: [
                {
                    text: "ID",
                    align: "left",
                    value: "id"
                },
                {
                    text: this.t("Uploaded at"),
                    align: "left",
                    value: "uploaded_at"
                },
                {
                    text: this.t("Rows"),
                    align: "left",
                    value: "rows"
                },
                {
                    text: this.t("Type"),
                    align: "end",
                    value: "type"
                },
                {
                    text: this.t("Status"),
                    align: "center",
                    value: "status"
                }
            ],
            app_url: settings.app_url
        };
    },
    computed: {
        ...mapState(["loadingUploadCsv", "paymentImports"])
    },
    methods: {
        status(item) {
            item.badgeClasses["badge-warning"] = false;
            item.badgeClasses["badge-danger"] = false;
            item.badgeClasses["badge-primary"] = false;
            if (item.status === "pending") {
                return this.t("Pending");
            } else if (item.status === "processing") {
                item.badgeClasses["badge-warning"] = true;
                return this.t("Processing");
            } else if (item.status === "finished") {
                item.badgeClasses["badge-primary"] = true;
                return this.t("Download");
            } else if (item.status === "failed") {
                item.badgeClasses["badge-danger"] = true;
                return this.t("Failed");
            } else {
                return this.t(item.status.charAt(0).toUpperCase() + item.status.slice(1));
            }
        },
        handleDownloadClick(item) {
            if (item.status === "finished") window.location = `${this.app_url}/upload-csv/?pi-id=${item.id}`;
        }
    }
};
</script>

<style scoped>
.badge {
    background-color: #d1dade;
    color: #5e5e5e;
    text-shadow: none;
    border-radius: 21px;
    padding: 0.3rem 1rem 4px;
    white-space: nowrap;
}
.badge-link {
    cursor: pointer;
}
.badge i {
    margin-right: 0.5rem;
}

.label-primary,
.badge-primary {
    background-color: #1ab394;
    color: #ffffff !important;
}

.label-success,
.badge-success {
    background-color: #1c84c6;
    color: #ffffff;
}

.label-warning,
.badge-warning {
    background-color: #f8ac59;
    color: #ffffff;
}

.label-danger,
.badge-danger {
    background-color: #ed5565;
    color: #ffffff;
}
</style>
